var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile=='pc')?_c('div',[_c('HomeMain')],1):_vm._e(),(_vm.isMobile == 'mobile')?_c('div',[_c('Mobile-Home')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }